export const cleanPhoneNumberToValidate = (phoneNumber: string) => {
  return `+${cleanString(phoneNumber.replace(/[^0-9]/g, ''))}`;
};

export const cleanString = (str: string) => {
  return str.replace(/\s/g, '');
};
